import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" アカウント一覧 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("アカウント招待 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_back_button = _resolveComponent("back-button")
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_vue_head_button_frame = _resolveComponent("vue-head-button-frame")
  const _component_account_list = _resolveComponent("account-list")
  const _component_account_invitation_list = _resolveComponent("account-invitation-list")
  const _component_tabs = _resolveComponent("tabs")
  const _component_vue_content_remain = _resolveComponent("vue-content-remain")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withCtx(() => [
      _createVNode(_component_vue_title, null, {
        default: _withCtx(() => [
          _createVNode("h2", null, [
            _createVNode(_component_back_button),
            _hoisted_1
          ])
        ]),
        _: 1
      }),
      (_ctx.clinicOwner)
        ? (_openBlock(), _createBlock(_component_vue_head_button_frame, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_normal_button, {
                class: "vue-head-button-frame-button-wide",
                state: "normal",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(`/w/${_ctx.clinicId}/invite_account`)))
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.clinicOwner)
        ? (_openBlock(), _createBlock(_component_vue_content_remain, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_tabs, {
                tabs: _ctx.tabs,
                onTab: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectTab($event)))
              }, {
                default: _withCtx(() => [
                  (_ctx.selectedIndex===0)
                    ? (_openBlock(), _createBlock(_component_account_list, {
                        key: 0,
                        style: {"border-top-left-radius":"0"}
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.selectedIndex===1)
                    ? (_openBlock(), _createBlock(_component_account_invitation_list, {
                        key: 1,
                        style: {"border-top-left-radius":"0"}
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["tabs"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_vue_content_remain, { key: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_account_list)
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}